import { GridRowSelectionMixin } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";
import { HeaderFilterType } from "../GridMixins/HeaderFiltersPlugin";

var orgCreateSelectColumn = GridRowSelectionMixin.createSelectColumn;
GridRowSelectionMixin.createSelectColumn = function (getMixin: () => GridRowSelectionMixin): Column {
    var col = orgCreateSelectColumn.call(this, function () {
        var mixin = getMixin && getMixin();
        mixin && mixin["grid"] && mixin["grid"].getGrid() && mixin["grid"].getGrid().onHeaderClick.subscribe(() => {
            setTimeout(mixin.updateSelectAll.bind(mixin), 0);
        });
        return mixin;
    }) as Column;
    col.minWidth = 32;
    col.maxWidth = 32;
    col.width = 32;
    col.headerFilterType = HeaderFilterType.disabled;
    return col;
};
